import { render, staticRenderFns } from "./notas.vue?vue&type=template&id=8681d72e&"
import script from "./notas.vue?vue&type=script&lang=js&"
export * from "./notas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports